<template>
  <div class="width-100">
    <div class="back" @click="toTop">
      <van-icon name="arrow-up" size="20px" color="#ffffff" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'HelloWorld',
  components: {},
  data() {
    return {
      gotop: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },

  created() {},
  methods: {
    handleScroll() {
      let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    }
  }
};
</script>

<style lang="less" scoped></style>
